import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import useNotification from '../notification/useNotification';
import useHandleGroupSearch from '../../pages/deviceManagement/useHandleGroupSearch';
import { userList } from '../../pages/users/listUserSlice';
import { inviteUser, selector as inviteUserApi } from './inviteUserSlice';
import { useSpinner } from '../../customHooks';
import { ICreateUser, ICreateUserResponse } from "../../common/types/userTypes";
import { getCookie, isSuccessResponse } from '../../common/utils';
import { selector as groupApi } from '../../pages/deviceManagement/groupSlice';
import { IGroupAlerts } from '../../common/types/alertsTypes';
import { validateEmail } from '../../common/utils';
export const useInviteUser = () => {
  const [parentOrg, setParentOrg] = useState<string>("");
  const dispatch = useDispatch();
  const inviteUserResponse = useSelector(inviteUserApi);
  const groupIdToHierarchyMap: Record<string, string> = useSelector(groupApi).groupIdToHierarchyMap;
  const [show, setShow] = useState(false);
  const [isEmptyGroupShown, setIsEmptyGroupShown] = useState<boolean>(true);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [role, setRole] = useState('');
  const [message, setMessage] = useState<string | null>();
  const [emailError, setEmailError] = useState<string>("");
  const [isPasswordEnable, setIsPasswordEnable] = useState<boolean>(false);
  useSpinner(inviteUserResponse.status);
  const { showSuccessNotification, showWarningNotification } = useNotification();

  const handleDataFromTreeView = (selectedGroup: IGroupAlerts) => {
    const data: IGroupAlerts = selectedGroup;
    const orgData = data?.id ? data.id : "";
    setParentOrg(orgData);
  };

  const {
    handleGroupInputChange,
    groupSearchQuery,
    nodesToDisplay,
    setGroupSearchQuery
  } = useHandleGroupSearch({ isEditable: false });

  const handleShow = () => {
    setShow(true);
    setGroupSearchQuery('');
  }

  const handleClose = () => {
    setEmailError("");
    setEmail("");
    setName("");
    setRole("");
    setMessage(null);
    setShow(false);
    setIsPasswordEnable(false);
  };
   const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
      setEmail(e.target.value);
      setEmailError(
        validateEmail(e.target.value) ? "" : "Please enter a valid email address"
      );
    };
  const closeNotification = () => {
    setMessage(null);
  }

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const orgId: string = getCookie("organizationId");
    const orgName: string = groupIdToHierarchyMap[orgId];
    const payload: ICreateUser = {
      email,
      name,
      role,
      groupId: parentOrg,
      organizationId: orgId,
      organizationName: orgName,
      isPasswordEnable: isPasswordEnable,
    }
    
    dispatchInviteUser(inviteUser, payload);
    handleClose();
  }

  const dispatchInviteUser = (
    action,
    payload: ICreateUser,
  ) => {
    try {
      dispatch(action(payload)).then((response) => {
        const inviteUserResponse: any = response;
        if (isSuccessResponse(inviteUserResponse.payload)) {
          dispatch(userList());
          showSuccessNotification(inviteUserResponse.payload.message);
        } else {
          showWarningNotification(inviteUserResponse.payload.response.data.message);
        }
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };
  

  return {
    show,
    name,
    email,
    role,
    message,
    isPasswordEnable,
    groupSearchQuery,
    nodesToDisplay,
    parentOrg,
    handleDataFromTreeView,
    setIsEmptyGroupShown,
    setSearchTerm,
    setEmail,
    setName,
    setRole,
    setMessage,
    handleGroupInputChange,
    handleShow,
    handleClose,
    closeNotification,
    handleOnSubmit,
    setIsPasswordEnable,
    emailError,
    handleEmailChange
  };
}